import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'oc-icon',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss']
})
export class IconsComponent implements OnInit, OnChanges {
  @Input() name;
  @Input() color;
  @Input() link;
  hex;

  constructor() { }

  ngOnInit() {
    this.setColor()
  }

  setColor() {
    if (this.color.indexOf('#') === 0) {
      this.hex = this.color;
    } else {
      switch (this.color) {
        case 'type-dark': this.hex = '#494949'; break;
        case 'type-neutral': this.hex = '#6E8099'; break;
        case 'type-light': this.hex = '#FAFAFA'; break;
        case 'system-error': this.hex = '#F17468'; break;
        case 'system-warning': this.hex = '#FCE48E'; break;
        case 'system-info': this.hex = '#94D69A'; break;
        case 'off-white': this.hex = '#FAFAFA'; break;
        case 'neutral-brighter': this.hex = '#F3F3F3'; break;
        case 'neutral': this.hex = '#E6E6E6'; break;
        case 'blue-darker': this.hex = '#0E2E5A'; break;
        case 'blue-dark': this.hex = '#394569'; break;
        case 'blue-light': this.hex = '#CBDDED'; break;
        case 'blue-lighter': this.hex = '#DAECFF'; break;
        case 'cta': this.hex = '#2673CD'; break;
        case 'approach-dark': this.hex = '#33694C'; break;
        case 'approach-light': this.hex = '#E3EDE7'; break;
        case 'tag-dark': this.hex = '#494949'; break;
        case 'tag-light': this.hex = '#DCDCDC'; break;
        default: this.hex = '#e0826c';
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.hasOwnProperty('color') && !changes.hasOwnProperty('name')) {
      this.setColor();
    }
  }
}
